import {
  RoomDescription,
  roomDescription,
  RoomId,
  roomId,
  RoomStartAt,
  roomStartAt,
  RoomTitle,
  roomTitle
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomUpdateRequestDTORaw) {
    JsonSchemaValidator.assert(RoomUpdateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomTitle"],
      properties: {
        roomId,
        roomTitle,
        roomDescription,
        roomStartAt
      },
      additionalProperties: false
    };
  }
}

interface RoomUpdateRequestDTORaw {
  roomId: RoomId;
  roomTitle: RoomTitle;
  roomDescription?: RoomDescription;
  roomStartAt?: RoomStartAt;
}
